import { Box, Button, Drawer, List, ListItem, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { Palette } from 'Palette';

interface StyledDrawerProps {
  expanded: boolean;
  tone?: keyof typeof Palette;
}

export const styledPageSX: SxProps<Theme> = {};

export const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'expanded' && prop !== 'tone',
})<StyledDrawerProps>(({ theme, expanded, tone, className }) => ({
  width: expanded ? 240 : 64,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),
  overflowX: 'hidden',
  '& .MuiDrawer-paper': {
    width: 'inherit',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    ...(tone && {
      backgroundColor: Palette[tone || 'default'].background,
      color: Palette[tone || 'default'].text,
    }),
  },
  className: `react-StyledDrawer ${className || ''}`.trim(),
}));

export const StyledList = styled(List)<{ className?: string }>(({ theme, className }) => ({
  paddingLeft: theme.spacing(3),
  className: `react-StyledList ${className || ''}`.trim(),
}));

export const StyledListItem = styled(ListItem)<{ className?: string }>(({ theme, className }) => ({
  display: 'list-item',
  padding: 0,
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary,
  className: `react-StyledListItem ${className || ''}`.trim(),
}));

export const StyledSwitchButtonRow = styled(Box)<{ className?: string }>(
  ({ theme, className }) => ({
    display: 'flex',
    gap: theme.spacing(2),
    margin: `${theme.spacing(2)} 0`,
    className: `react-StyledSwitchButtonRow ${className || ''}`.trim(),
  }),
);

export const StyledSwitchButton = styled(Button)<{
  selected?: boolean;
  className?: string;
}>(({ theme, selected, className }) => ({
  padding: theme.spacing(1, 2),
  backgroundColor: selected ? theme.palette.primary.main : theme.palette.grey[300],
  color: selected ? theme.palette.primary.contrastText : theme.palette.text.primary,
  '&:hover': {
    backgroundColor: selected ? theme.palette.primary.dark : theme.palette.grey[400],
  },
  borderRadius: theme.shape.borderRadius,
  textTransform: 'none',
  className: `react-StyledSwitchButton ${className || ''}`.trim(),
}));

export const StyledListWrapper = styled(Box)<{ className?: string }>(({ theme, className }) => ({
  marginBottom: theme.spacing(4),
  className: `react-StyledListWrapper ${className || ''}`.trim(),
}));

export const StyledToggleContainer = styled(Box)<{ className?: string }>(
  ({ theme, className }) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    className: `react-StyledToggleContainer ${className || ''}`.trim(),
  }),
);

export const StyledBox = styled(Box)<{ className?: string }>(({ theme, className }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(1),
  className: `react-StyledBox ${className || ''}`.trim(),
}));
